// This can be removed when we use a http only refresh token

export const longTermTokenStorageKey = 'token';

export const clearLongTermTokenFromSessionStorage = (): void => {
  sessionStorage.removeItem(longTermTokenStorageKey);
};

export const getLongTermTokenFromSessionStorage = (): string => {
  return sessionStorage.getItem(longTermTokenStorageKey);
};

export const saveLongTermTokenToSessionStorage = (token: string): void => {
  sessionStorage.setItem(longTermTokenStorageKey, token);
};
